<template>
  <b-modal title="Editar distribuidor" cancel-title="Cerrar" ok-title="Actualizar" class="modal-success" v-model="open" @cancel="revert" @ok.prevent="actualizar" @hidden="clear">
      <template v-if="errors.length !== 0">
        <div class="alert alert-danger" role="alert">
          <template v-for="(error, key) in errors">
            <strong>{{key | filerName}}</strong>
            <ul v-for="valor in error">
              <li>{{valor}}</li>
            </ul>
          </template>
          <ul>
          </ul>
        </div>
      </template>
    </div>
    <div class="row">
      <div class="col-md-6">
        <b-form-group id="nombre" description="Nombre del distribuidor." label="Nombre">
          <b-form-input type="text" disabled id="nombre" v-model.trim="draft.Nombre"></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-6">
         <b-form-group id="correo" description="Correo del distribuidor." label="Correo">
          <b-form-input type="email" id="correo" v-model.trim="draft.Correo"></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group id="telefono" description="Teléfono del distribuidor." label="Teléfono">
        <b-form-input type="text" v-mask="['(###) ### - ## - ##',' (##) ## - ## - ## - ##']" id="telefono" v-model.trim="draft.Telefono"></b-form-input>
      </b-form-group>
      </div>
      <div class="col-md-6">
         <b-form-group id="contacto" description="Contacto del distribuidor." label="Contacto">
        <b-form-input type="text"  id="contacto" v-model.trim="draft.Contacto"></b-form-input>
      </b-form-group>
      </div>
      <div class="col-md-12">
         <b-form-group id="notificacion" description="Notificación de timbres agotados." label="Notificación">
        <b-form-input type="text" v-mask="'#########'" id="notificacion" v-model.trim="draft.NotificarTotal"></b-form-input>
      </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group id="Negativos" description="Habilitar que un distribuidor genere sobregiro de timbres." label="Saldo negativo">
         <c-switch type="3d" variant="primary"  @change="changeNegativos" :checked="Negativos"/>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group v-if="draft.Negativo" id="cantidadNegativos" description="Cantidad maxima de Negativos." label="Cantidad negativo">
          <b-form-input type="text"  v-mask="'#########'"  id="cantidadNegativos" v-model.trim="draft.CantidadNegativa"></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group id="status" description="Estatus del distribuidor." label="Status">
         <c-switch type="3d" variant="primary" @change="changeEstatus" :checked="Estatus"/>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group id="grupos" description="Habilitar grupos." label="Grupos">
          <c-switch type="3d" variant="primary" @change="changeGrupos" :checked="Grupos"/>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group id="grupos" description="Habilitar ambientes." label="Ambientes">
          <c-switch type="3d" variant="primary" @change="changeAmbientes" :checked="Ambientes"/>
        </b-form-group>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-right">
        <b-btn variant="secondary" @click="open=false">
          Cerrar
        </b-btn>
        <b-btn :disable="loading" variant="primary" @click="actualizar">
            Actualizar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>

import EventBus from '@/event-bus.js'
import cSwitch from '@/components/Switch'

export default {
  name: 'Editar',
  components: {
    cSwitch
  },
  data () {
    return {
      saved: {},
      open: false,
      errors: [],
      draft: {}
    }
  },
  filters: {
    fetchErrors (errors) {
      return (typeof errors === 'undefined') ? '' : (errors.length > 0) ? errors[0] : ''
    },
    filerName (value) {
      let names = {
        'CantidadNegativa': 'Cantidad de Negativos',
        'NotificarTotal': 'Notificacion'
      }
      return (typeof names[value] === 'undefined') ? value : names[value]
    }
  },
  methods: {
    revert () {
      this.draft.Nombre = this.saved.Nombre
      this.draft.Correo = this.saved.Correo
      this.draft.Telefono = this.saved.Telefono
      this.draft.Contacto = this.saved.Contacto
      this.draft.Negativo = this.saved.Negativo
      this.draft.CantidadNegativa = (this.saved.CantidadNegativa === null) ? this.saved.CantidadNegativa : 0
      this.draft.NotificarTotal = this.saved.NotificarTotal
      this.draft.Estatus = this.saved.Estatus
      this.draft.Grupos = this.saved.Grupos
      this.draft.Ambientes = this.saved.Ambientes
      this.clear()
    },
    changeAmbientes (ambiente) {
      this.draft.Ambientes = ambiente
    },
    changeGrupos (grupos) {
      this.draft.Grupos = grupos
    },
    changeNegativos (negativo) {
      this.draft.Negativo = negativo
    },
    actualizar () {
      this.draft.CantidadNegativa = (this.draft.CantidadNegativa === null) ? 0 : this.draft.CantidadNegativa
      var promise = this.$store.dispatch('actualizarDistribuidor', this.draft)
      promise.then(response => {
        EventBus.$emit('disableOrderDistribuidores', false)
        this.clear()
      }).catch(errorResponse => {
        this.errors = errorResponse.response.data
        this.loading = false
      })
    },
    changeEstatus (estatus) {
      this.draft.Estatus = estatus
    },
    NombreHasErrors () {
      let message = (typeof this.errors.Nombre === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    RFCHasErrors () {
      let message = (typeof this.errors.Rfc === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    CorreoHasErrors () {
      let message = (typeof this.errors.Correo === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    PhoneHasError () {
      let message = (typeof this.errors.Telefono === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    ContactoHasError () {
      let message = (typeof this.errors.Contacto === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    NotificarTotalHasError () {
      let message = (typeof this.errors.NotificarTotal === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    NegativosHasErrors () {
      let message = (typeof this.errors.CantidadNegativa === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    CantidadNegativaHasError () {
      let message = (typeof this.errors.CantidadNegativa === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    EstatusHasErrors () {
      let message = (typeof this.errors.Estatus === 'undefined') ? 'valid' : 'invalid'
      return message
    },
    clear () {
      this.draft = {}
      this.errors = []
      this.open = false
      this.loading = false
      EventBus.$emit('disableOrderDistribuidores', false)
    }
  },
  computed: {
    Estatus () {
      return (this.draft.Estatus === 1)
    },
    Negativos () {
      return (this.draft.Negativo === 1)
    },
    Ambientes () {
      return (this.draft.Ambientes === 1)
    },
    Grupos () {
      return (this.draft.Grupos === 1)
    }
  },
  created () {
    EventBus.$on('OpenEditar', response => {
      this.open = true
      this.draft = response
      this.saved = JSON.parse(JSON.stringify(response))
    })
  }
}
</script>
<style>
.switch.switch-3d.switch-primary
{
  background: #20a8d8 !important;
  border-color: #1985ac;
  border-radius: 50em !important;
  border: none !important;
}
.switch-label {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Distribuidores/Crud/Editar.vue